import { render } from "./card10.vue?vue&type=template&id=db9b781c&scoped=true"
import script from "./card10.vue?vue&type=script&lang=js"
export * from "./card10.vue?vue&type=script&lang=js"

import "./card10.vue?vue&type=style&index=0&id=db9b781c&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Library/Containers/com.tencent.xinWeChat/Data/Documents/xwechat_files/wxid_1rhhjrwiu7uq22_9030/msg/file/2026-08/ubang-copilot-agents-web-deploy-2026-08-31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db9b781c"]])

export default __exports__